import React from 'react';
import { find, get, cloneDeep, findIndex, forEach, isEqual, last, isUndefined, merge } from 'lodash';

// React view component to render
import { orderToDo as OrderToDoView } from 'ui/views/widgets/orderToDo';
import { OrderToDoService } from 'services/orderToDo';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { OrderToDo } from 'ui/containers/OrderToDo';
 *
 * // render
 * <OrderToDo propName='propValue'/>
 */
export class OrderToDo extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state= {
            filterValues: [],
            options: this.props.options,
            fetchingFoemFieleds: false
        };

        this.handlefFlterChange = this.handlefFlterChange.bind( this );
        this.fetchFormFields = this.fetchFormFields.bind( this );
        this.onFormSubmit = this.onFormSubmit.bind( this );

         // member prescriptions instance
         this.orderToDoService = new OrderToDoService();
    }

    handlefFlterChange( { name, value } ) {
        log.debug( 'OrderToDo.handlefFlterChange()' );

        const options = cloneDeep( this.state.options );
        const filterValues = cloneDeep( this.state.filterValues );
        const fieldDataIndex = findIndex( this.props.fields, { name: name } );

        if( -1 === fieldDataIndex ) {
            return;
        }

        // get prev type value
        const typeValue = get( this.state.filterValues[ 1 ] );

        // set the values
        forEach( this.props.fields, ( field, index ) => {
            if( index === fieldDataIndex ) {
                filterValues[ index ] = value;
            } else if( index > fieldDataIndex ) {
                filterValues[ index ] = '';
            }
        } );

        // set the options for the next filter
        const nextFilter = this.props.fields[ fieldDataIndex + 1 ];
        const optionList = get( this.state.options, `${ this.props.fields[ fieldDataIndex ].options }`, [] );
        if( nextFilter ) {
            options[ `${nextFilter.options}` ] = find( optionList, { value: value } )[ 'options' ];
        }

        this.setState( {
            filterValues,
            options: options
        }, ()  => {

            if( 'type' === name && ! isEqual( typeValue, filterValues[ 1 ] ) ) {

                const lastFieldOptionName = last( this.props.fields )[ 'options' ];
                const isSubtyperequired = ! isUndefined( this.state.options[ `${lastFieldOptionName}` ] );

                if( ! isSubtyperequired ) {
                    this.setState( { fetchingFoemFieleds: true }, () => {
                        this.fetchFormFields(  );
                    } );
                }
               
            } else if( 'subtype' === name && ! isEqual( typeValue, last( filterValues ) ) ) {
                this.setState( { fetchingFoemFieleds: true }, () => {
                    this.fetchFormFields( );
                } );
            }
        } );

    }

    async fetchFormFields(  ) {
        log.debug( 'OrderToDo.fetchFormFields()' );

        this.orderToDoService.cancel();

        // get the url
        const urlMapObject =  find( this.props.urlMap, { 'value': this.state.filterValues[ 1 ] } );

        const _data = {};
        forEach( this.props.fields, ( field, index ) => {
            _data[ field.name ] = this.state.filterValues[ index ];
        } );

        const { status, data } = await this.orderToDoService.fetchFormComponents( {
            url: urlMapObject.url,
            data: merge( { data: _data, ...this.props.requestPayload } )
        } );

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            this.setState( {
                fetchingFoemFieleds: false,
                formFields: data.formFields,
                navActions: data.navActions,
                formData: data.formData,
            } );
        }
    }

    /**
     * Action executed when user submits form
     */
    async onFormSubmit ( formData ) {
        log.debug( 'OrderToDo.onFormSubmit()' );

        // get context and submit action url
        // const context = get( this.props, 'context', {} );
        const submitAction = find( this.state.navActions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        // submit form data and get status of submission
        const { status } = await this.orderToDoService.submitFormData( {
            url: submitAction.url,
            data: {
                context: get( this.props, 'requestPayload.context', {} ),
                data: merge( formData, get( this.props, 'requestPayload.data', {} ) )
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open(); // show error overlay
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <OrderToDoView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.onFormSubmit }
                onFilterChange={ this.handlefFlterChange }
            />
        );
    }
}

// set display name
OrderToDo.displayName = 'OrderToDo';

// set default props
OrderToDo.defaultProps = {};

// prop types
OrderToDo.propTypes = {};
